import StringUtil from "../../../../../../app/util/StringUtil";
import InputValidationStateBo from "../../../../../../form/input/InputValidationStateBo";
import InputValidator from "../../../../../../form/input/InputValidator";
import InputValidatorI from "../../../../../../form/input/InputValidatorI";


export default class BankIbanValidator implements InputValidatorI {

    private value?: string;

    constructor(newValue?: string) {
        this.value = newValue;
    }


    // *****************
    // Validator
    // ********************
    validate(): InputValidationStateBo {
        // Nur Zahlen
        const onlyDigit = StringUtil.replaceNonNumeric(this.value);

        if (StringUtil.isBlank(onlyDigit)) {
            return InputValidationStateBo.createInValid("Geben Sie bitte Ihre IBAN an.")
        }


        if (onlyDigit && !InputValidator.isLength(onlyDigit, 20, 20)) {
            return InputValidationStateBo.createInValid("Geben Sie bitte eine gültige IBAN mit 20 Zahlen an.")
        }

        // *** Wert is gueltig!
        return InputValidationStateBo.createValid();
    }

}